import { render, staticRenderFns } from "./TabbedPortletContainer.vue?vue&type=template&id=52bf114c&"
import script from "./TabbedPortletContainer.vue?vue&type=script&lang=js&"
export * from "./TabbedPortletContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports